import { z } from "zod";

export const DRIVER_PASSWORD_MIN_LENGTH = 12;

export const RecaptchaErrorResponseSchema = z.object({
  recaptcha_token: z.array(z.string()),
});

export const UserSchema = z.object({
  email: z.string(),
  date_joined: z.string(),
});

export enum DriverAccountMode {
  EXISTING = "existing",
  CREATE = "create",
}

export const UserFormSchema = z
  .object({
    mode: z.nativeEnum(DriverAccountMode),
    email: z.string().email({ message: "validation.field.invalidEmail" }),
    password: z.string().nullish(),
  })
  .superRefine((user, context) => {
    if (
      user.mode === DriverAccountMode.CREATE &&
      (!user.password || user.password.length < DRIVER_PASSWORD_MIN_LENGTH)
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation.driver.password",
        path: ["password"],
      });
    }
  });

export const DriverAccountSchema = z.object({
  id: z.number(),
  email: z.string().email(),
});

export type DriverAccount = z.infer<typeof DriverAccountSchema>;
